module.exports = __webpack_public_path__ + "apple-touch-icon.bc963f46.png";